<template>
    <f7-page
        name="FAQ"
        class="onboardingBg"
    >
        <f7-navbar
            large
            large-transparent
            title-large="FAQ"
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>FAQ</f7-nav-title>
        </f7-navbar>
        <template v-for="(section, i) in sections">
            <f7-block-title
                :key="`section-title-${i}`"
                class="blockTitle"
            >{{ section.title }}</f7-block-title>
            <f7-list
                :key="`section-list-${i}`"
                accordion-list
            >
                <f7-list-item
                    v-for="(item,index) in section.items"
                    :title="item.question"
                    :key="`faq-${index}`"
                    accordion-item
                    @accordion:opened="openFAQ(item)"
                >
                    <f7-accordion-content>
                        <f7-block
                            class="foldedBlock"
                            v-html="item.answer"
                        />
                    </f7-accordion-content>
                </f7-list-item>
            </f7-list>
        </template>
    </f7-page>
</template>

<script>
import faqs from '../../js/faq';

export default {
    store: ['api'],
    data () {
        return {
            sections: [],
        };
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    created: function () {
        let currentSection = '';
        for (let i = 0; i < faqs.length; i++) {
            const faq = faqs[i];
            if (faq.section !== currentSection) {
                currentSection = faq.section;
                this.sections.push({
                    title: faq.section,
                    items: []
                })
            }
            this.sections[this.sections.length - 1].items.push(faq);
        }
    },
    mounted: function () { },
    methods: {
        openFAQ: function (item) {
            this.$events.fire('trackEvent', 'support_faq_opened', 'faq', 0, item.question, {
                reason: item.section,
                question: item.question,
            });
        },
        openFeedback: function () {
            if (pgap) {
                cordova.plugins.email.open({
                    to: 'support@getcoral.app',
                    subject: 'Coral Feedback',
                    body: 'Please mention what browser or phone your are using. Thank you!',
                    isHtml: true
                });
            } else {
                window.open(
                    'mailto:support@getcoral.app?subject=' +
                    'Coral Feedback' +
                    '&body=' +
                    'Please mention what browser or phone your are using. Thank you!'
                );
            }
        }
    }
};
</script>

<style lang="less" scoped>
.blockTitle {
    text-transform: uppercase;
    font-family: AndesMedium;
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 22px;
}
.foldedBlock {
    text-align: left;
    font-family: 'Andes';
    font-size: 15px;
    letter-spacing: normal;
    font-weight: normal;
    padding-bottom: 40px;
}
.center {
    text-align: center;
}
</style>
